$(function () {
    let section = $('#seccionSitios')
    if (section.get(0) == null) {
        return
    }
    let timeoutConsultarIdNombre = null
    let vueApp = new Vue({
        el: section.get(0),
        data: {
            loader: false,
            filtros: { page: 1, buscar: null, cliente_id: null },
            sitios: [],
            modalTitulo: 'Nuevo sitio',
            sitio: {suscripcion_tipo: null,
                id_nombre_no_disponible: false, no_nuevo_sitio: true}
        },
        mounted() {
            this.getSitios()
        },
        methods: {
            limpiarId() {
                this.sitio.id_nombre = this.sitio.id_nombre.replace(/[^a-zA-Z0-9\-]/g, '');

                this.consultarId(this.sitio)
            },

            formatUrl(url) {
                if (!url) return '#';
                return url.startsWith('http://') || url.startsWith('https://')
                    ? url
                    : `https://${url}`;
            },
            consultarId(sitio){
                let vue = this
                if(timeoutConsultarIdNombre != null){
                    clearTimeout(timeoutConsultarIdNombre)
                    timeoutConsultarIdNombre = null
                }

                timeoutConsultarIdNombre = setTimeout(() => {
                    axios.get('/admin/sitios/validar-id-nombre', {
                        params: {
                            sitio_id: sitio.id,
                            id_nombre: sitio.id_nombre
                        },
                    })
                    .then((response) => {
                        vue.sitio.id_nombre_no_disponible = !response.data.disponible
                    })
                    timeoutConsultarIdNombre = null
                }, 300)

            },
            getSitios(pagina = null) {
                if (this.loader) {
                    return
                }
                if (pagina != null) {
                    this.filtros.page = pagina
                }
                this.loader = true
                axios
                    .get('/admin/sitios/json', {
                        params: this.filtros,
                    })
                    .then((response) => {
                        vueApp.loader = false
                        if (response.data.error) {
                            swal({
                                icon: "info",
                                title: response.data.error,
                                button: {
                                    text: "Aceptar",
                                    closeModal: true,
                                },
                            })
                            return
                        }
                        vueApp.sitios = response.data.sitios.data;
                        vueApp.filtros.total = response.data.sitios.total;
                        vueApp.filtros.per_page = response.data.sitios.per_page;
                        vueApp.filtros.from = response.data.sitios.from;
                        vueApp.filtros.to = response.data.sitios.to;
                    })
                    .catch((error) => {
                        vueApp.loader = false
                        swal({
                            icon: "info",
                            title: "Ocurrió un error inesperado",
                            button: {
                                text: "Aceptar",
                                closeModal: true,
                            },
                        })
                    })
            },
            eliminar(id) {
                swal({
                    title: '¿Eliminar registro?',
                    icon: 'warning',
                    buttons: { cancel: 'Cancelar', ok: 'Aceptar', },
                    dangerMode: true,
                }).then((ok) => {
                    if (ok) {
                        axios
                            .delete('/admin/sitios/' + id)
                            .then(function (response) {
                                if (response.data.error) {
                                    swal({
                                        icon: "info",
                                        title: response.data.error,
                                        button: {
                                            text: "Aceptar",
                                            closeModal: true,
                                        },
                                    })
                                    return
                                }
                                vueApp.getSitios(1)
                            })
                            .catch((error) => {
                                swal({
                                    icon: "info",
                                    title: "Ocurrió un error inesperado",
                                    button: {
                                        text: "Aceptar",
                                        closeModal: true,
                                    },
                                })
                            })
                    }
                })
            },
            agregar() {
                $('#formSitio')[0].reset()
                $("#actualizar_sitio").attr("checked", true)
                this.sitio = Object.assign({}, {
                    suscripcion_tipo: null, id_nombre_no_disponible: false,
                    no_nuevo_sitio: false
                })
                this.modalTitulo = 'Nuevo sitio'
                $('#modalSitio').modal('show')
                this.validar()
            },
            editar(sitio) {
                $("#actualizar_sitio").attr("checked", false)
                this.sitio = Object.assign({},
                    {...sitio,...{
                        id_nombre_no_disponible: false,
                            no_nuevo_sitio: sitio.fecha_expira != null
                    }})
                console.log(sitio.id == null || sitio.fecha_expira == null)
                this.modalTitulo = 'Editar sitio'
                $('#modalSitio').modal('show')
                this.validar()
            },
            validar() {
                $('#formSitio').validarForm((form) => {
                    if(vueApp.sitio.no_nuevo_sitio &&
                        (vueApp.sitio.fecha_expira == null || vueApp.sitio.fecha_expira.length == 0)){
                        swal("Debe seleccionar una fecha de renovación", "", "info")
                        return
                    }
                    vueApp.guardar(form)
                })
            },
            guardar(form) {
                $('#btnGuardar').loader('show')
                let formData = new FormData(form)
                axios
                    .post('/admin/sitios/guardar', formData)
                    .then((respuesta) => {
                        $('#btnGuardar').loader('hide')
                        if (respuesta.data.error) {
                            swal({
                                icon: "info",
                                title: respuesta.data.error,
                                button: {
                                    text: "Aceptar",
                                    closeModal: true,
                                },
                            })
                            return
                        }
                        $('#modalSitio').modal('hide')
                        vueApp.getSitios(1)
                    })
                    .catch((error) => {
                        console.log(error)
                        $('#btnGuardar').loader('hide')
                        swal({
                            icon: "info",
                            title: "Ocurrió un error inesperado",
                            button: {
                                text: "Aceptar",
                                closeModal: true,
                            },
                        })
                    })
            },
            cancelarPagoRecurrente(sitio){
                swal({
                    title: '¿Cancelar pago recurrente de '+sitio.nombre+'?',
                    icon: 'warning',
                    buttons: { cancel: 'Cancelar', ok: 'Aceptar', },
                    dangerMode: true,
                }).then((ok) => {
                    if (ok) {
                        axios
                            .post('/admin/sitios/' + sitio.id + '/cancelar-pago-recurrente')
                            .then(function (response) {
                                if (response.data.error) {
                                    swal({
                                        icon: "info",
                                        title: response.data.error,
                                        button: {
                                            text: "Aceptar",
                                            closeModal: true,
                                        },
                                    })
                                    return
                                }
                                vueApp.getSitios(1)
                                swal({
                                    icon: "success",
                                    title: "Pago recurrente cancelado",
                                    button: {
                                        text: "Aceptar",
                                        closeModal: true,
                                    },
                                })
                            })
                            .catch((error) => {
                                swal({
                                    icon: "info",
                                    title: "Ocurrió un error inesperado",
                                    button: {
                                        text: "Aceptar",
                                        closeModal: true,
                                    },
                                })
                            })
                    }
                })
            }
        },
    })
})
